import React, { useEffect } from 'react';
import AOS from 'aos';
import "aos/dist/aos.css";
import './index.css';
import {
  BrowserRouter as Router,
  Routes,
  Route
} from 'react-router-dom';

// All pages
import Home from './pages/Home';
import Contact from './pages/Contact';
import DemoProduct from './pages/DemoProduct';
import SME from './pages/SME.js';
import PrivacyPolicy from './pages/PrivacyPolicy';

// Components
import { useDocTitle } from './components/CustomHook';
import ScrollToTop from './components/ScrollToTop';
import PageWrapper from './components/PageWrapper';

// App component
function App() {
  // Initialize AOS for animations on scroll
  useEffect(() => {
    AOS.init({
      once: true,
      duration: 1000,
      easing: 'ease-out-cubic',
    });
  }, []);

  // Custom hook to set the page's document title
  useDocTitle("Yaniva Ventures");

  // WhatsApp Chat Link
  const whatsappLink = "https://wa.me/917016142002";

  return (
    <>
      <Router>
        <ScrollToTop>
          {/* Define all the routes for different pages */}
          <Routes>
            <Route path="/" element={<PageWrapper><Home /></PageWrapper>} />
            <Route path="/contact" element={<PageWrapper><Contact /></PageWrapper>} />
            <Route path="/get-demo" element={<PageWrapper><DemoProduct /></PageWrapper>} />
            <Route path="/sme" element={<PageWrapper><SME /></PageWrapper>} /> 
            <Route path="/privacy-policy" element={<PageWrapper><PrivacyPolicy /></PageWrapper>} />
          </Routes>

          {/* Ensure Chatbot and WhatsApp icons are visible on all pages */}
          <div className="whatsapp-icon">
            <a href={whatsappLink} target="_blank" rel="noopener noreferrer">
              <img 
                src={require('./images/whatsappmain.png')}
                alt="WhatsApp Chat" 
                width="48" 
                height="48"
              />
            </a>
          </div>

        </ScrollToTop>
      </Router>
    </>
  );
}

export default App;
